import { SectionTitle } from "@/components/base/ui/SectionTitle";
import Link from "next/link";
import { microCMSClient } from "@/utils/client";
import { News } from "@/types/news";
import { format } from "date-fns";
import ja from "date-fns/locale/ja";
import { Breadcrumb } from "@/components/base/Breadcrumb";
import React from "react";
import { ScrollToTop } from "@/components/base/ui/ScrollToTop";

const NewsIndexPage = ({ news }: { news: News[] }) => {
  const breadcrumbs = [
    {
      title: "お知らせ",
    },
  ];
  return (
    <>
      <main className={"pb-20"}>
        <div className={"mb-10 max-w-[1440px] m-auto px-4 py-2"}>
          <Breadcrumb breadcrumbs={breadcrumbs} />
        </div>
        <div className={"max-w-[960px] m-auto px-5 md:px-0"}>
          <div className={"mb-8"}>
            <SectionTitle title={"お知らせ"} isBorder={false} />
          </div>
          <div>
            {news.map((_news, index) => (
              <Link
                href={`/news/${_news.id}`}
                key={index}
                className={`md:px-5 py-8 ${
                  index === 0 && "border-t"
                } border-b block hover:opacity-60 duration-100`}
              >
                <p className={"mb-3 md:text-lg"}>{_news.title}</p>
                <span
                  className={
                    "flex items-center text-gray-500 text-sm leading-[1]"
                  }
                >
                  <p className={"mr-3"}>お知らせ</p>
                  <p className={"mr-3 mt-[-2px]"}>|</p>
                  <p>
                    {format(new Date(_news.publishedAt), "yyyy年M月d日", {
                      locale: ja,
                    })}
                  </p>
                </span>
              </Link>
            ))}
          </div>
        </div>
        <ScrollToTop />
      </main>
    </>
  );
};

export async function getStaticProps() {
  const [news] = await Promise.all([
    microCMSClient.get({
      endpoint: "news",
      queries: {
        limit: 100,
      },
    }),
  ]);
  return {
    props: {
      news: news.contents,
    },
  };
}
export default NewsIndexPage;
